<style scoped lang="scss" type="text/scss">
    .right-panel-container {
        .images-container {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            .image-item {
                border-radius: .15rem;
                width: calc(50% - .5rem);
                display: flex;
                flex-direction: column;

                .uploader-wrap {
                    box-sizing: border-box;
                    width: 100%;

                    .uploader {
                        width: 100%;
                        height: 15rem;
                    }
                }

                .sample-photo {
                    margin-top: .5rem;
                    margin-bottom: -.25rem;
                }
            }
        }
    }
</style>

<template>
    <card class="right-panel-container">
        <el-form :model="teamInfo" ref="form" :rules="rules" label-width="100px">
            <block-divider>基本信息</block-divider>

            <el-form-item label="队伍名称" prop="name">
                <el-input v-model="teamInfo.name" ></el-input>
            </el-form-item>

            <div class="images-container">
                <div class="image-item flag-image">
                    <block-divider>队旗信息</block-divider>
                    <div class="uploader-wrap">
                        <i-single-image-uploader
                                class="uploader"
                                ref="flagImageUploader"
                                v-model="flagUploadImage"
                                :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                                :limit-size="2 * 1024 * 1024"
                                :src="teamInfo.flag_url"
                                title="队旗"
                                reversed
                                @file-uploaded="flagFileUploaded"
                        >
                            <div class="extra-info">
                                <info-panel class="info-panel" size="small">
                                    图片类型：JPG / SVG / PNG / JPEG
                                </info-panel>
                                <info-panel class="info-panel" size="small">
                                    大小限制：2 MB 以下
                                </info-panel>
                                <info-panel class="info-panel" size="small">
                                    尺寸建议：1280 像素 * 800 像素
                                </info-panel>
                            </div>
                        </i-single-image-uploader>
                    </div>
                    <sample-photo class="sample-photo" center
                                  src="//robo-static.oss-cn-qingdao.aliyuncs.com/images/samples/team-flag.jpeg"
                                  tip="建议使用 4 号旗，当学校仅有一个参赛队时，可上传学校旗帜图片"
                                  title="队旗">
                    </sample-photo>
                </div>
                <div class="image-item clothes-image">
                    <block-divider>队服信息</block-divider>
                    <div class="uploader-wrap">
                        <i-single-image-uploader
                                class="uploader"
                                ref="clothesImageUploader"
                                v-model="clothesUploadImage"
                                :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                                :limit-size="2 * 1024 * 1024"
                                :src="teamInfo.clothes_url"
                                title="队服"
                                reversed
                                @file-uploaded="clothesFileUploaded"
                        >
                            <div class="extra-info">
                                <info-panel class="info-panel" size="small">
                                    图片类型：JPG / SVG / PNG / JPEG
                                </info-panel>
                                <info-panel class="info-panel" size="small">
                                    大小限制：2 MB 以下
                                </info-panel>
                                <info-panel class="info-panel" size="small">
                                    尺寸建议：1366 像素 * 768 像素
                                </info-panel>
                            </div>
                        </i-single-image-uploader>
                    </div>
                    <sample-photo class="sample-photo" center
                                  src="//robo-static.oss-cn-qingdao.aliyuncs.com/images/samples/team-clothes.jpg"
                                  tip="图片应包含队服的正反面"
                                  title="队服">
                    </sample-photo>
                </div>
            </div>



          <div class="images-container">
            <div class="image-item flag-image">
              <block-divider>带有slogon的实验室照片</block-divider>
              <div class="uploader-wrap">
                <i-single-image-uploader
                    class="uploader"
                    ref="slogonImageUploader"
                    v-model="slogonUploadImage"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="2 * 1024 * 1024"
                    :src="teamInfo.slogon_url"
                    title="带有slogon的实验室照片"
                    reversed
                    @file-uploaded="slogonFileUploaded"
                >
                  <div class="extra-info">
                    <info-panel class="info-panel" size="small">
                      图片类型：JPG / SVG / PNG / JPEG
                    </info-panel>
                    <info-panel class="info-panel" size="small">
                      大小限制：2 MB 以下
                    </info-panel>
                    <info-panel class="info-panel" size="small">
                      尺寸建议：1280 像素 * 800 像素
                    </info-panel>
                  </div>
                </i-single-image-uploader>
              </div>
              <sample-photo class="sample-photo" center
                            src="//robo-static.oss-cn-qingdao.aliyuncs.com/images/samples/team-flag.jpeg"
                            tip="带有slogon的实验室照片"
                            title="带有slogon的实验室照片">
              </sample-photo>
            </div>
          </div>

          <block-divider>团队slogon</block-divider>

          <el-form-item label="团队slogon" prop="team_slogon">
            <el-input v-model="teamInfo.team_slogon" placeholder="请填写团队slogon"></el-input>
          </el-form-item>

            <block-divider>官方自媒体</block-divider>

            <el-form-item label="微信公众号" prop="wechat_official_account">
                <el-input v-model="teamInfo.wechat_official_account" placeholder="请填写微信公众号"></el-input>
            </el-form-item>

            <el-form-item label="抖音" prop="tiktok_official_account">
                <el-input v-model="teamInfo.tiktok_official_account" placeholder="请填写抖音账号"></el-input>
            </el-form-item>

            <el-form-item label="B站" prop="bilibili_official_account">
                <el-input v-model="teamInfo.bilibili_official_account" placeholder="请填写B站主页网址"></el-input>
            </el-form-item>

            <el-form-item class="submit-buttons">
                <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
                <el-button @click="reset()">重置</el-button>
            </el-form-item>
        </el-form>
    </card>
</template>

<script>
    import Card from '../../../../../components/card';
    import BlockDivider from '../../../../../components/divider/block';
    import ISingleImageUploader from '../../../../../components/i-uploader/single-image-uploader';
    import InfoPanel from '../../../../../components/info-panel';
    import UserSearchBox from '../../../../sub-components/user-search-box';
    import _ from 'lodash';
    import SamplePhoto from '../../../../../components/sample-photo/index';

    export default {
        name: '',
        components: {
            Card,
            BlockDivider,
            ISingleImageUploader,
            InfoPanel,
            UserSearchBox,
            SamplePhoto
        },
        data () {
            const checkLabArea = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('基地面积只能是数字'));
                }
                if (+value < 0) {
                    callback(new Error('基地面积不能小于 0'));
                }
                if (+value > 100000) {
                    callback(new Error('基地面积不能超过 100,000 平方米'));
                }
            };
            return {
                teamInfo: {},
                requesting: false,
                flagUploadImage: null,
                slogonUploadImage: null,
                clothesUploadImage: null,
                rules: {
                    name: [
                        {required: true, message: '队名不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                    ],
                  team_slogon:[
                    {required: true, message: '请输入团队slogon', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                  ],
                  wechat_official_account: [
                    {message: '请输入微信公众号', trigger: 'blur'},
                      {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                  ],
                  tiktok_official_account: [
                    {message: '请输入抖音账号', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                  ],
                  bilibili_official_account: [
                    {message: '请输入B站主页链接', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                  ],

                    lab_area: [
                        {required: true, message: '请输入基地面积', trigger: 'blur'},
                        {validator: checkLabArea, trigger: 'blur'}
                    ],
                    lab_administrator_id: [
                        {required: true, message: '请选择基地主任', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedTeamInfo () {
                return this.$store.state.team.currentManagedTeamInfo;
            },
            currentManagedTeamId () {
                return this.$store.state.team.currentManagedTeamId;
            }
        },
        watch: {
            currentManagedTeamInfo (info) {
                this.$refs.form.clearValidate();
                this.teamInfo = this.extract(info);
            }
        },
        methods: {
            extract (info) {
                return {
                    name: _.get(info, 'name', null),
                    clothes_url: _.get(info, 'clothes.url', null),
                    flag_url: _.get(info, 'flag.url', null),
                    slogon_url: _.get(info, 'slogon.url', null),
                    lab_administrator_id: _.get(info, 'lab_administrator.id', null),
                    lab_area: +_.get(info, 'lab_area', null),
                  team_slogon: _.get(info, 'team_slogon', null),
                    wechat_official_account: _.get(info, 'wechat_official_account', null),
                  tiktok_official_account: _.get(info, 'tiktok_official_account', null),
                  bilibili_official_account: _.get(info, 'bilibili_official_account', null),
                };
            },
            update () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    this.$normalRequest('team/updateTeam', {
                        id: this.currentManagedTeamId,
                        name: this.teamInfo.name,
                        lab_administrator_id: this.teamInfo.lab_administrator_id,
                        lab_area: this.teamInfo.lab_area,
                      team_slogon: this.teamInfo.team_slogon,
                        wechat_official_account: this.teamInfo.wechat_official_account,
                      tiktok_official_account: this.teamInfo.tiktok_official_account,
                      bilibili_official_account: this.teamInfo.bilibili_official_account
                    }, '更新成功', true, this, 'requesting').then(_ => {
                        this.$refs.form.clearValidate();
                        this.reload();
                    }).catch(_ => {
                    });
                });
            },
            reset () {
                this.teamInfo = this.extract(this.currentManagedTeamInfo);
                this.$refs.form.clearValidate();
            },
            flagFileUploaded (fileInfo, _, throwFail) {
                this.$normalRequest('team/updateTeamFlag', {
                    id: this.currentManagedTeamId,
                    ...fileInfo
                }, '队旗更新成功').then(_ => {
                    this.reloadManagedTeamInfo();
                    fileInfo.finish_callback();
                }).catch(_ => {
                    throwFail();
                    fileInfo.finish_callback();
                });
            },
            clothesFileUploaded (fileInfo, _, throwFail) {
                this.$normalRequest('team/updateTeamClothes', {
                    id: this.currentManagedTeamId,
                    ...fileInfo
                }, '队服更新成功').then(_ => {
                    this.reloadManagedTeamInfo();
                    fileInfo.finish_callback();
                }).catch(_ => {
                    throwFail();
                    fileInfo.finish_callback();
                });
            },
            slogonFileUploaded (fileInfo, _, throwFail) {
                this.$normalRequest('team/updateSlogon', {
                    id: this.currentManagedTeamId,
                    ...fileInfo
                }, '带有slogon的实验室照片更新成功').then(_ => {
                    this.reloadManagedTeamInfo();
                    fileInfo.finish_callback();
                }).catch(_ => {
                    throwFail();
                    fileInfo.finish_callback();
                });
            },
            reloadManagedTeamInfo () {
                this.$store.dispatch('team/loadManagedTeamInfo').then();
            },
            reload () {
                this.reloadManagedTeamInfo();
                this.$store.dispatch('team/loadManagedTeams').then();
            }
        }
    };
</script>
